(($)=>{

    "use strict";

	$('.play-video').each(function(){

		$(this).click(function(event){
			event.preventDefault();

			$(this).addClass('playing');

			var video_src = $(this).attr('data-src');
			if (video_src == '#') {
				var poster = $('.wp_video').attr('data-poster');
				var video = '';
				$('.wp_video').find('.source').each(function(){
					video += '<source src="' + $(this).attr('data-src') + '" type="' + $(this).attr('data-type') + '" >';
				});
				video = '<video controls autoplay loop poster="'+poster+'">'+video+'</video>';
			} else {
				var video = '<iframe src="'+video_src+'?enablejsapi=1&rel=0&wmode=opaque" frameborder="0" allowfullscreen></iframe>';
			}

			$('body').append('<div id="cover"></div>');
			$('body').append('<div id="video_block"></div>');
			$('#video_block').append('<div id="iframe_wrapper"></div>');
			$('#iframe_wrapper').append(video);
			$('#iframe_wrapper').append('<div id="button_close">&times;</div>');

			var html_h = $(window).scrollTop();
			var y = html_h + 60;

			$('#video_block').css('top', y); 
		});

	});



	$(document).on('click', '#button_close', function (event) {
		$('#video_block').remove();
		$('#cover').remove();
		$('.play-video').removeClass('playing');
		event.stopPropagation();
	});
	$(document).on('click', function (event) {
		if($('#video_block').length) {
			if ($(event.target).closest('#iframe_wrapper').length) {return;}
			if ($(event.target).closest('.play-video').length) {return;}
			$('#video_block').remove();
			$('#cover').remove();
			$('.play-video').removeClass('playing');
			event.stopPropagation();
		}
	});

})(jQuery);